module.exports = __webpack_public_path__ + "static/media/home_slide_prev.943c80da.svg";